import { IntlShape } from 'react-intl';

const parseNumber = (intl: IntlShape, value: string) => {
    const group = intl.formatNumber(1111).replace(/1/g, '');
    const decimal = intl.formatNumber(1.1).replace(/1/g, '');

    let reversedVal = value.replace(new RegExp(`\\${group}`, 'g'), '');
    reversedVal = reversedVal.replace(new RegExp(`\\${decimal}`, 'g'), '.');

    return parseFloat(reversedVal);
};

export default parseNumber;
